import { Inject, Injectable } from "@angular/core";
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';

declare const ExcelJS: any;
// declare let jsPDF;


@Injectable()
export class GenerateExcelService {
  sName: string = 'Sheet';
  excelFileName: string = 'Mission.xlsx';
  blobType: string = 'application/vndata.openxmlformats-officedocument.spreadsheetml.sheet';
  hearder: string = 'LIST OF SPEAKER';
  title: string = 'HEADS OF STATE';
  title1: string = 'HEADS OF GOVERNMENT';
  title2: string = 'MINISTERS FOR FOREIGN AFFAIRS';
  sheetWidth: number = 100;
  speakerPerCol: number = 14;

  // countries: any = [];
  constructor() { }
  addRowStyle() {}
  generateExcel(mission,representativeList){
console.log(mission);
console.log(representativeList);
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'web';
    workbook.created = new Date();
    workbook.modified = new Date();

    const worksheet = workbook.addWorksheet(
      this.sName,
      {
        pageSetup: { fitToPage: true ,orientation:'potrait', paperSize: 9, fitToHeight:0 , fitTowidth:1  }
      },
      { views: [{ state: 'frozen', ySplit: 12, xSplit: 5 }] }
    );

    worksheet.addRow();
    const titleRow = worksheet.getRow(1);

    const cellTitle1=titleRow.getCell(1);
    cellTitle1.value = {
      richText: [
        {
          font: {bold:false, size:12, color:{argb: '2a5284'}},
          text: mission.MC_Entity
        },
        
        ]
    };

    cellTitle1.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    cellTitle1.border = {
      
    };    
    worksheet.mergeCells(`A${titleRow.number}:C${titleRow.number}`);

   
    titleRow.height = Math.ceil(titleRow.getCell(1).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 25;

    worksheet.addRow();
    const mRow1 = worksheet.getRow(2);

    const mCell1=mRow1.getCell(1);
    mCell1.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Address"
        },
        
        ]
    };

    mCell1.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell1.border = {
      
    };    
    worksheet.mergeCells(`A${mRow1.number}:C${mRow1.number}`);
    const mCell2=mRow1.getCell(4);
    mCell2.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_Address
        },
        
        ]
    };

    mCell2.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell2.border = {
      
    };    
    worksheet.mergeCells(`D${mRow1.number}:F${mRow1.number}`);

   
    mRow1.height = Math.ceil(mRow1.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 50;

    worksheet.addRow();
    const mRow2 = worksheet.getRow(3);

    const mCell21=mRow2.getCell(1);
    
    mCell21.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Telephone"
        },
        
        ]
    };

    mCell21.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell21.border = {
      
    };    
    worksheet.mergeCells(`A${mRow2.number}:C${mRow2.number}`);
    const mCell22=mRow2.getCell(4);
    mCell22.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_Telephone
        },
        
        ]
    };

    mCell22.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell22.border = {
      
    };    
    worksheet.mergeCells(`D${mRow2.number}:F${mRow2.number}`);

   
    mRow2.height = Math.ceil(mRow2.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 50;

    worksheet.addRow();
    const mRow3 = worksheet.getRow(4);

    const mCell31=mRow3.getCell(1);
    mCell31.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Telefax"
        },
        
        ]
    };

    mCell31.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell31.border = {
      
    };    
    worksheet.mergeCells(`A${mRow3.number}:C${mRow3.number}`);
    const mCell32=mRow3.getCell(4);
    mCell32.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_Telefax
        },
        
        ]
    };

    mCell32.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell32.border = {
      
    };    
    worksheet.mergeCells(`D${mRow3.number}:F${mRow3.number}`);

   
    mRow3.height = Math.ceil(mRow3.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 50;



    worksheet.addRow();
    const mRow4 = worksheet.getRow(5);

    const mCell41=mRow4.getCell(1);
    mCell41.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "E-mail"
        },
        
        ]
    };

    mCell41.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell41.border = {
      
    };    
    worksheet.mergeCells(`A${mRow4.number}:C${mRow4.number}`);
    const mCell42=mRow4.getCell(4);
    mCell42.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_eMail
        },
        
        ]
    };

    mCell42.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell42.border = {
      
    };    
    worksheet.mergeCells(`D${mRow4.number}:F${mRow4.number}`);

   
    mRow4.height = Math.ceil(mRow4.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 50;







    worksheet.addRow();
    const mRow5 = worksheet.getRow(6);

    const mCell51=mRow5.getCell(1);
    mCell51.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Website"
        },
        
        ]
    };

    mCell51.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell51.border = {
      
    };    
    worksheet.mergeCells(`A${mRow5.number}:C${mRow5.number}`);
    const mCell52=mRow5.getCell(4);
    mCell52.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_WebSite?mission.MC_WebSite:""
        },
        
        ]
    };

    mCell52.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell52.border = {
      
    };    
    worksheet.mergeCells(`D${mRow5.number}:F${mRow5.number}`);

   
    mRow5.height = Math.ceil(mRow5.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 40;







    
    worksheet.addRow();
    const mRow6 = worksheet.getRow(7);

    const mCell61=mRow6.getCell(1);
    mCell61.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Social Media"
        },
        
        ]
    };

    mCell61.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell61.border = {
      
    };    
    worksheet.mergeCells(`A${mRow6.number}:C${mRow6.number}`);
    const mCell62=mRow6.getCell(4);
    mCell62.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_SocialMedia?mission.MC_SocialMedia:""
        },
        
        ]
    };

    mCell62.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell62.border = {
      
    };    
    worksheet.mergeCells(`D${mRow6.number}:F${mRow6.number}`);

   
    mRow6.height = Math.ceil(mRow6.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 20;






    
    worksheet.addRow();
    const mRow7 = worksheet.getRow(8);

    const mCell71=mRow7.getCell(1);
    mCell71.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Correspondence"
        },
        
        ]
    };

    mCell71.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell71.border = {
      
    };    
    worksheet.mergeCells(`A${mRow7.number}:C${mRow7.number}`);
    const mCell72=mRow7.getCell(4);
    mCell72.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_UNCorrespondenceLanguage?mission.MC_UNCorrespondenceLanguage:""
        },
        
        ]
    };

    mCell72.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell72.border = {
      
    };    
    worksheet.mergeCells(`D${mRow7.number}:F${mRow7.number}`);

   
    mRow7.height = Math.ceil(mRow7.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 20;







    worksheet.addRow();
    const mRow8 = worksheet.getRow(9);

    const mCell81=mRow8.getCell(1);
    mCell81.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "National holiday"
        },
        
        ]
    };

    mCell81.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell81.border = {
      
    };    
    worksheet.mergeCells(`A${mRow8.number}:C${mRow8.number}`);
    const mCell82=mRow8.getCell(4);
    mCell82.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: mission.MC_Holiday?mission.MC_Holiday:""
        },
        
        ]
    };

    mCell82.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell82.border = {
      
    };    
    worksheet.mergeCells(`D${mRow8.number}:F${mRow8.number}`);

   
    mRow8.height = Math.ceil(mRow8.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 15;











    worksheet.addRow();
    worksheet.addRow();

    const mRow9 = worksheet.getRow(11);

    const mCell91=mRow9.getCell(1);
    mCell91.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text: "Phone / Extension"
        },
        
        ]
    };

    mCell91.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell91.border = {
      bottom: {style:'thin'},

    };    
    worksheet.mergeCells(`A${mRow9.number}:C${mRow9.number}`);
    const mCell92=mRow9.getCell(4);
    mCell92.value = {
      richText: [
        {
          font: {bold:false, size:10, color:{argb: '2a5284'}},
          text:"Name and Title"
        },
        
        ]
    };

    mCell92.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell92.border = {
        bottom: {style:'thin'},

    };    
    worksheet.mergeCells(`D${mRow9.number}:F${mRow9.number}`);

   
    mRow9.height = Math.ceil(mRow9.getCell(4).value.richText[0].text.length / (this.sheetWidth * 0.50)) * 15;





    var rowNum=12;
 var i=0;
    representativeList.forEach(element => {
   
   

    worksheet.addRow();
    const mRow = worksheet.getRow(rowNum);

    const mCell1=mRow.getCell(1);
    mCell1.value = {
      richText: [
        {
          font: {bold:false, size:10},
          text: element["BB_PhnNumber"]
        },
        
        ]
    };

    mCell1.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true };
    mCell1.border = {
      
    };    
    worksheet.mergeCells(`A${mRow.number}:C${mRow.number}`);
    const mCell2=mRow.getCell(4);
    mCell2.alignment = { vertical: 'middle', horizontal: 'left', wrapText:true,  };

    mCell2.value = {
      richText: [
        {
          font: {bold:false, size:10},
          text: element["BB_Title"]+" "+element["BB_FirstName"]+" "

        },
        {
          font: {bold:true, size:10},
          text: element["BB_LastName"]
        }
        ,
        {
          font: {bold:false, size:10},
          text:element["BB_Dipl_Rank"] && element["BB_Dipl_Rank"]!="(no dipl rank)" ? " \n"+ element["BB_Dipl_Rank"]:""
        }
        ,
        {
          font: {bold:false, size:10},
          text:(element["BB_Function"]) ? i==0? (element["BB_Cred_Presented"]? " \n"+ element["BB_Function"]+" (DPC:"+ moment(element["BB_Cred_Presented"]).format('DD MMM YYYY')+")": " \n"+ element["BB_Function"]):" \n"+element["BB_Function"] : ""
        }
        ,
        {
          font: {bold:false, size:10},
          text:(!element["BB_Function"] && i==0) ? " (DPC:"+ moment(element["BB_Cred_Presented"]).format('DD MMM YYYY')+")": ""
        }
        ,
        {
          font: {bold:false, size:10},
          text:element["BB_Email"]  ? " \n"+ element["BB_Email"]:""
        }
        ,
        {
          font: {bold:false, size:10},
          text:element["BB_Spouse"] ? " \n"+ element["BB_Spouse"]:""
        }




      
        
        ]
    };

    mCell2.border = {
      
    };    
    worksheet.mergeCells(`D${mRow.number}:F${mRow.number}`);
var max=0;
mRow.getCell(4).value.richText.forEach(text => {
  max=max+text.text.length;
});
   
    mRow.height = Math.ceil(max / (this.sheetWidth * 0.50)) * 50;

rowNum+=1;
i++;
    });
  
    
    workbook.xlsx.writeBuffer().then(speakerList => {
      console.log(speakerList);
      const blob = new Blob([speakerList], { type: this.blobType });
      console.log(blob);
      var date=moment(new Date()).format('YYYYMMDD');
      FileSaver.saveAs(blob, 'eBlueBook-'+mission.MC_Entity+'.xlsx', true);
    });

    

  }  
}


// WEBPACK FOOTER //
// ./src/app/services/generate-excel.service.ts